<template>
  <div class="notice-container-wrap" v-loading="loading">
    <div class="notice-container">

      <div class="notice-left">
        <div class="notice-left-block">
          <div class="tit">分类</div>
          <ul>
            <li :class="{'active': mode === 'update' && !param.id}" @click="handleChangeMode('update')">
              <i class="icon iconfont iconicon_folder"></i>
              更新弹窗
            </li>
            <li :class="{'active': mode === 'notice' && !param.id}" @click="handleChangeMode('notice')">
              <i class="icon iconfont iconicon_folder"></i>
              通知弹窗
            </li>
          </ul>
        </div>
        <div class="notice-left-block">
          <div class="tit">
            <div class="icon-wrap activeIconHover" @click="handleChangeListShow('showDraftList')">
              <i
                class="icon iconfont iconicon_arrow_gantt_chart1"
                :class="{ 'show': showDraftList }"
              ></i>
            </div>
            草稿箱
          </div>
          <ul v-show="showDraftList">
            <li
              v-for="item in draftList"
              :key="item.id"
              :class="{'active': param.id === item.id}"
              @click="getNoticeDetailFn(item.id)"
            >
              <i class="icon iconfont iconicon_log"></i>
              {{ getItemTitle(item) }}
              <span class="type-icon" :class="{'draft': item.release_status === 1}">
                {{ item.release_status === 1 ? '草稿' : '待发布' }}
              </span>
              <i @click.stop="handleDel(item.id)" class="icon iconfont iconicon_delete activeIconHover"></i>
            </li>
          </ul>
        </div>
        <div class="notice-left-block">
          <div class="tit">
            <div class="icon-wrap activeIconHover" @click="handleChangeListShow('showPublishedList')">
              <i
                class="icon iconfont iconicon_arrow_gantt_chart1"
                :class="{ 'show': showPublishedList }"
              ></i>
            </div>
            发布记录
          </div>
          <ul v-show="showPublishedList">
            <li
              v-for="item in publishedList"
              :key="item.id"
              :class="{'active': param.id === item.id}"
              @click="getNoticeDetailFn(item.id)"
            >
              <i class="icon iconfont iconicon_log"></i>
              {{ getItemTitle(item) }}
              <i @click.stop="handleDel(item.id)" class="icon iconfont iconicon_delete activeIconHover"></i>
            </li>
          </ul>
        </div>
      </div>

      <div class="notice-edit-wrap" v-show="param.release_status === 1 || param.release_status === 3">
        <Notice-edit
          ref="noticeEdit"
          :mode="mode"
          :param="param"
          :titleHref="titleHref"
          :showEditor="showEditor"
          @update="handleUpdate"
          @handleShowEditor="showEditor = true"
        ></Notice-edit>
      </div>

      <div class="notice-view">
        <Notice-view
          :mode="mode"
          :param="param"
          :titleHref="titleHref"
        ></Notice-view>
      </div>
    </div>

    <footer v-show="param.release_status === 1 || param.release_status === 3">
      <div class="footer-left">
        <p v-if="scheduled_release_time">
          发布时间：该内容将于 {{ scheduled_release_time }} 发布
        </p>
      </div>

      <div class="footer-right">
        <el-date-picker
          v-if="timing"
          v-model="scheduled_release_time"
          ref="time"
          format="yyyy-MM-dd HH:mm"
          value-format="yyyy-MM-dd HH:mm"
          popper-class="wf-picker-panel help-edit-btns-date"
          type="datetime"
          :picker-options="pickerOptions"
          placeholder="选择日期时间">
        </el-date-picker>
        <span class="btn" :class="{ disabled }" @click="handlePublish(1)">保存为草稿</span>
        <!-- <span class="btn">预览</span> -->
        <div class="btn-wrap">
          <span class="btn-publish" :class="{ disabled }" @click="handlePublish(2)">
            {{ timing ? '定时发布' : '发布' }}
          </span>
          <el-popover
            v-model="showPublishType"
            placement="top-end"
            trigger="click"
            :offset="0"
          >
            <span class="notice-footer-popover-btn" @click="handleChangePublishType">
              {{ timing ? '发布' : '定时发布' }}
            </span>
            <i slot="reference" class="icon iconfont iconicon_arrow_task_1"  :class="{ disabled }"></i>
          </el-popover>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
// 组件
import NoticeEdit from './components/noticeEdit.vue'
import NoticeView from './components/noticeView.vue'
import moment from 'moment';
// api
import api from '@/services/api/help/help.js'

export default {
  components: {
    NoticeEdit,
    NoticeView
  },
  created() {
    this.init()
  },
  computed: {
    // 标题或者内容未填写
    disabled() {
      return !this.param.title || !this.param.notification_content
    }
  },
  data() {
    return {
      loading: false,
      pickerOptions: {
        selectableRange:'00:00:00 - 23:59:59',
        disabledDate(time) {
          var date = new Date();
          date.setFullYear(date.getFullYear()+2);
          date.setDate(date.getDate()-1);
          return (time.getTime() < Date.now() - 8.64e7)||(time.getTime()>date.getTime());
        }
      },
      scheduled_release_time: '', //发布时间
      draftList: [], // 草稿列表
      publishedList: [], // 已发布列表
      showPublishType: false, // 发布类型浮窗开关
      timing: false, // 是否定时发布
      mode: 'update', // 弹窗类型
      titleHref: '', // 更新弹窗标题带的链接
      param: {
        title: '',
        notification_content: '',
        release_status: 1, // 1：草稿，2：正式发布，3：定时发布
        category: 1 // 1：更新弹窗，2：通知弹窗
      },
      showEditor: true, // 是否展示编辑框
      showDraftList: true, // 展开草稿列表
      showPublishedList: true // 展开已发布列表
    }
  },
  watch: {
    scheduled_release_time() {
      this.selectable()
    }
  },
  methods: {
    selectable() {
        const date = moment(this.scheduled_release_time).startOf('day').format('x');
        const nowDate = moment().startOf('day').format('x');
        // 如果选择的是今天 则需要禁用已经过去的时间节点
        if (date <= nowDate) {
            // 默认选择的最新时间 是当前时间的1分钟后
            this.pickerOptions.selectableRange = (
                `${moment().add(1, 'minutes').format('HH:mm:ss')} - 23:59:59`
            );
        }
        // 如果是以后的日期，则不需要禁用时间节点
        else {
            this.pickerOptions.selectableRange = '00:00:00 - 23:59:59';
        }
    },
    async init () {
      this.draftList = await this.getListFn(1) // 获取草稿列表
      this.publishedList = await this.getListFn(2) // 获取已发布列表
    },
    // 获取列表
    async getListFn(release_status) {
      const res = await api.getNoticesList({ release_status })
      return this.getTitleFn(res.data)
    },
    // 将列表的标题改为只有文字的格式
    getTitleFn(list) {
      let _list = []
      list.forEach(item => {
        const _item = JSON.parse(JSON.stringify(item))
        if (_item.category === 1) {
          // 更新弹窗的编辑状态下，如果标题带有链接，将文字跟链接提取出来
          const _title = _item.title
          const _changeTitle = this.processTitle(_title)
          if (~_title.indexOf('<p>')) {
            // 纯文字
            _item.title = _changeTitle
          } else if (~_title.indexOf('<a')) {
            // 带有链接的
            const arr = _changeTitle.split('^')
            _item.title = arr[0]
          }
        }
        _list.push(_item)
      })

      return _list
    },
    // 切换弹窗样式
    handleChangeMode(mode) {
      if (this.mode === mode && !this.param.id) return

      this.mode = mode
      this.resetFn(mode) //重置弹窗内容
    },
    resetFn(mode) {
      const _mode = mode ? mode : 'update'
      this.param = {
        title: '',
        notification_content: '',
        release_status: 1, // 1：草稿，2：正式发布，3：定时发布
        category: _mode === 'update' ? 1 : 2 // 1：更新弹窗，2：通知弹窗
      }
      this.titleHref = ''
      this.timing = false
      this.scheduled_release_time = ''
      this.showEditor = false
      this.$refs.noticeEdit.resetFn()
    },
    // 展开或者折叠列表
    handleChangeListShow(val) {
      this[val] = !this[val]
    },
    // 获取弹窗详情
    async getNoticeDetailFn(id) {
      this.showEditor = false
      this.titleHref = ''
      this.$refs.noticeEdit.resetFn()
      const res = await api.getNoticeDetail({ id })
      if (res) {
        const { id, title, notification_content, release_status, category } = res
        this.mode = category === 1 ? 'update' : 'notice'
        this.param = {
          id,
          title,
          notification_content,
          release_status,
          category
        }

        if (this.param.category === 1) {
          // 更新弹窗的编辑状态下，如果标题带有链接，将文字跟链接提取出来
          const _title = this.param.title
          const _changeTitle = this.processTitle(_title)
          if (~_title.indexOf('<p')) {
            // 纯文字
            this.param.title = _changeTitle
          } else if (~_title.indexOf('<a')) {
            // 带有链接的
            const arr = _changeTitle.split('^')
            this.param.title = arr[0]
            this.titleHref = arr[1]
            // console.log(arr,this.titleHref, 111)
          }
        }

        if (res.release_status === 3) {
          // 定时发布
          this.timing = true
        } else {
          this.timing = false
        }

        this.scheduled_release_time = res.released_time
      }
    },
    getItemTitle(item) {
      let _title = ''
      let _timeHtml = ''
      const _time = item.release_status === 1 ? item.update_time : item.released_time
      _timeHtml = `-${ _time.split(' ')[0].replace(/-/g, '/') }`
      if (item.category === 1) {
        // 更新弹窗
        _title = `更新弹窗${_timeHtml}`
      } else if (item.category === 2) {
        // 通知弹窗
        _title = `通知弹窗${_timeHtml}`
      }

      return _title
    },
    // 提取title文字方法
    processTitle(title) {
      // 匹配 <p> 标签
      const pRegex = /<p[^>]*>(.*?)<\/p>/i;
      // 匹配 <a> 标签及其 href 属性
      const aRegex = /<a[^>]*href=['"](.*?)['"][^>]*>(.*?)<\/a>/i;

      let result = title;

      // 判断是否是 <p> 标签
      if (pRegex.test(title)) {
        result = title.replace(pRegex, '$1');
      }
      // 判断是否是 <a> 标签
      else if (aRegex.test(title)) {
        result = title.replace(aRegex, '$2^$1');
      }

      return result;
    },
    // 删除弹窗
    handleDel(id) {
      this.$wfAlert('warning', '确认删除该弹窗吗?', '', '删除', 'warning').then(async () => {
        const res = await api.delNotice({ id })
        if (res) {
          this.$message({
            message: '删除弹窗成功',
            type: 'success'
          })
          this.init()
          this.resetFn()
        }
      }).catch(() => {
        console.log('执行异常')
        next(false)
      })
    },
    handleChangePublishType() {
      this.showPublishType = false
      this.timing = !this.timing
    },
    handleUpdate(obj, val, href) {
      this.param[obj] = val
      if (obj === 'title') {
        this.titleHref = href
      }
    },
    // 发布
    handlePublish(release_status) {
      if (!this.param.title || !this.param.notification_content) return

      this.loading = true
      let _msg = ''

      if (this.param.category === 1) {
        // 更新弹窗，需要将title变为html格式
        const _html = this.titleHref ?
          `<a href="${ this.titleHref }">${ this.param.title }</a>` :
          `<p>${ this.param.title }</p>`
        this.param.title = _html
      }
      if (release_status === 1) {
        // 存至草稿
        this.param.release_status = 1
        _msg = '弹窗已存至草稿箱'
      } else {
        // 发布
        if (this.timing) {
          // 定时发布
          this.param.release_status = 3
          this.param.released_time = this.scheduled_release_time
          _msg = '弹窗定时发布成功'
        } else {
          // 正式发布
          this.param.release_status = 2
          _msg = '弹窗正式发布成功'
        }
      }

      this.submitFn(_msg) // 发布
    },
    async submitFn(_msg) {
      const _api = this.param.id ? api.updateNotice : api.addNotice
      // console.log(this.param, _api, 111)
      const res = await _api(this.param)
      if (res) {
        this.$message({
          message: _msg,
          type: 'success'
        })
        this.init()
        this.resetFn()
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";
.notice-container-wrap {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.notice-container {
  height: 0;
  flex: 1;
  overflow-y: scroll;
  width: 100%;
  display: flex;
  border-bottom: 1px solid rgba(32, 32, 32, .08);
  .notice-left {
    width: 346px;
    padding: 16px 24px 0;
    box-sizing: border-box;
    border-right: 1px solid rgba(32, 32, 32, .08);
    .notice-left-block {
      padding: 24px 0 16px;
      border-top: 1px solid rgba(32, 32, 32, .08);
      &:first-child {
        padding-top: 0;
        border-top: none;
      }
      .tit {
        display: flex;
        align-items: center;
        font-size: 14px;
        line-height: 18px;
        @include fontColorOpacity(.6);
        margin-bottom: 8px;
        .icon-wrap {
          margin-right: 4px;
        }
        i {
          font-size: 12px;
          @include fontColorOpacity(.24);
          transition: all .3s;
          transform: rotate(-90deg);
          &.show {
            transform: rotate(0deg);
          }
        }
      }
      ul {
        max-height: 400px;
        overflow-y: scroll;
        li {
          width: 100%;
          height: 40px;
          display: flex;
          align-items: center;
          padding: 0 17px;
          box-sizing: border-box;
          font-size: 14px;
          position: relative;
          cursor: pointer;
          border-radius: 4px;
          &.active {
            @include bgColorOpacity(.08);
            &:hover {
              @include bgColorOpacity(.08);
            }
          }
          &:hover {
            @include bgColorOpacity(.04);
            .type-icon {
              display: none;
            }
            .iconicon_delete {
              visibility: visible;
            }
          }
          .type-icon {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 24px;
            padding: 0 8px;
            background: rgba(255, 152, 0, .16);
            border-radius: 4px;
            font-size: 12px;
            color: #FF9800;
            position: absolute;
            right: 16px;
            top: 50%;
            transform: translate(0, -50%);
            &.draft {
              @include bgColorOpacity(.08);
              @include fontColorOpacity(.6);
            }
          }
          i {
            @include fontColorOpacity(.6);
            margin-right: 8px;
            &.iconicon_delete {
              margin: 0;
              color: #FF3939;
              position: absolute;
              right: 12px;
              top: 50%;
              transform: translate(0, -50%);
              visibility: hidden;
            }
          }
        }
      }
    }
  }

  .notice-edit-wrap {
    flex: 1;
    padding: 32px 24px 0;
    box-sizing: border-box;
    border-right: 1px solid rgba(32, 32, 32, .08);
  }

  .notice-view {
    width: 440px;
    padding: 32px 40px 0;
    box-sizing: border-box;

  }
}

footer {
  width: 100%;
  height: 64px;
  padding: 0 24px 0 32px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .footer-left {
    p {
      font-size: 14px;
      @include fontColorOpacity(.6);
      line-height: 64px;
    }
  }
  .footer-right {
    display: flex;
    justify-content: flex-end;
  }
  .disabled {
    cursor: not-allowed;
    background: rgba(32, 32, 32, 0.24) !important;
    color: #fff !important;
    border: none !important;
  }
  .btn,
  .btn-wrap {
    cursor: pointer;
    display: flex;
    align-items: center;
    height: 32px;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 14px;
    &.btn {
      justify-content: center;
      padding: 0 16px;
      border: 1px solid rgba(32, 32, 32, .16);
      margin: 0 24px;
      &:hover {
        @include bgColorOpacity(.06);
      }
      &:active {
        @include bgColorOpacity(.12);
      }
    }
    &.btn-wrap {
      width: 108px;
      color: #fff;
      line-height: 32px;
      border-radius: 4px;
      overflow: hidden;
      .btn-publish,
      .iconicon_arrow_task_1 {
        background: #2682FF;
        display: flex;
        align-items: center;
        justify-content: center;
        &:hover {
          background: #2573DE;
        }
        &:active {
          background: #2560B1;
        }
        &.btn-publish {
          width: 76px;
        }
        &.iconicon_arrow_task_1 {
          width: 32px;
        }
      }
    }
  }
}
.notice-footer-popover-btn {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 108px;
  height: 40px;
  border-radius: 4px;
  box-sizing: border-box;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, .16);
  font-size: 14px;
  &:hover {
    @include bgColorOpacity(.06);
  }
  &:active {
    @include bgColorOpacity(.12);
  }
}
</style>
